export const getExpandablePagePath = (
    showAll: boolean,
    expandPageId?: string,
    pagePath?: string,
    navigationItems: any[] = []
): string | null => {
    if (!showAll || !expandPageId) {
        return null;
    }

    if (pagePath) {
        return `/${pagePath}/${expandPageId}`;
    }

    const navItem = navigationItems.find((item) => item.pageId === expandPageId);
    if (navItem?.title) {
        const formattedPath = navItem.title.toLowerCase();
        return `/${formattedPath}`;
    }

    return null;
};
